import React from 'react';
import Icon from '../../../components/AppIcon';

const ClientCategoryList = ({ categories, selectedCategory, onCategorySelect, searchQuery, onSearchChange }) => {
  return (
    <div className="h-full flex flex-col bg-card rounded-2xl border-2 border-border shadow-warm-lg overflow-hidden" style={{
      borderColor: 'rgba(184, 134, 11, 0.3)',
      background: 'linear-gradient(135deg, #1A1A1A 0%, #242424 100%)'
    }}>
      <div className="p-4 border-b-2 border-border" style={{
        background: 'linear-gradient(135deg, rgba(184, 134, 11, 0.12) 0%, rgba(218, 165, 32, 0.12) 100%)'
      }}>
        <h3 className="text-lg font-heading font-bold text-foreground mb-4">
          فئات العملاء
        </h3>
        <div className="relative">
          <Icon 
            name="Search" 
            size={18} 
            color="#B8860B"
            className="absolute right-3 top-1/2 -translate-y-1/2"
          />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            placeholder="بحث في الفئات..."
            className="w-full pr-10 pl-4 py-2.5 text-sm bg-background/50 border-2 border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all"
            style={{
              borderColor: 'rgba(184, 134, 11, 0.2)'
            }}
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-3">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategorySelect(category?.id)}
            className={`w-full flex items-center justify-between p-4 mb-2 rounded-xl transition-all duration-250 border-2 ${
              selectedCategory === category?.id
                ? 'bg-primary text-primary-foreground shadow-warm border-primary'
                : 'hover:bg-muted/50 text-foreground border-transparent hover:border-border'
            }`}
            style={{
              background: selectedCategory === category?.id 
                ? 'linear-gradient(135deg, rgba(184, 134, 11, 0.9) 0%, rgba(218, 165, 32, 0.9) 100%)'
                : undefined
            }}
          >
            <div className="flex items-center gap-4">
              <div className={`p-2 rounded-lg ${
                selectedCategory === category?.id
                  ? 'bg-primary-foreground/20'
                  : 'bg-primary/10'
              }`}>
                <Icon 
                  name={category?.icon} 
                  size={20}
                  color={selectedCategory === category?.id ? 'currentColor' : '#B8860B'}
                />
              </div>
              <span className="text-sm font-medium">{category?.name}</span>
            </div>
            <span className={`px-3 py-1.5 rounded-full text-xs font-bold border-2 ${
              selectedCategory === category?.id
                ? 'bg-primary-foreground text-primary border-primary-foreground'
                : 'bg-accent/20 text-accent-foreground border-accent/30'
            }`}>
              {category?.count}
            </span>
          </button>
        ))}
      </div>
      <div className="p-4 border-t-2 border-border" style={{
        background: 'linear-gradient(135deg, rgba(184, 134, 11, 0.08) 0%, rgba(218, 165, 32, 0.08) 100%)'
      }}>
        <div className="flex items-center justify-between text-sm">
          <span className="font-medium text-muted-foreground">إجمالي العملاء</span>
          <span className="font-data font-bold text-foreground text-lg" style={{ color: '#B8860B' }}>
            {categories?.reduce((sum, cat) => sum + cat?.count, 0)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ClientCategoryList;